import { setProps, getProps } from '../props';
import { clearSubcontractor } from '../State/subcontractor';
import fetchSubcontractor from '../Services/fetchSubcontractor';

export default (props) => (dispatch) => {
  const oldProps = getProps();
  setProps(props);
  
  // Check if the subcontractor ID has changed
  const oldSubcontractorId = oldProps && oldProps.match && oldProps.match.params && oldProps.match.params.id;
  const newSubcontractorId = props && props.match && props.match.params && props.match.params.id;
  
  if (oldSubcontractorId && newSubcontractorId && oldSubcontractorId !== newSubcontractorId) {
    // Clear the old subcontractor data and show loading state
    dispatch(clearSubcontractor());
    
    // Fetch the new subcontractor
    dispatch(fetchSubcontractor());
  }
};
